var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYinyonglouceng(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 232"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 126",
    d: "M16.75 6.00001L13.75 17L0.75 17L4.75 6L16.75 6.00001Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-2-outside-1_28_1990",
    maskUnits: "userSpaceOnUse",
    x: 0.75,
    y: 0,
    width: 10,
    height: 7,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 0.75,
    width: 10,
    height: 7
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.75 1L6.75 3V6H9.75V3H7.75L8.75 1H7.75ZM4.75 6V3H2.75L3.75 1H2.75L1.75 3V6H4.75Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.75 1L6.75 3V6H9.75V3H7.75L8.75 1H7.75ZM4.75 6V3H2.75L3.75 1H2.75L1.75 3V6H4.75Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 3L5.85557 2.55279L5.75 2.76393V3H6.75ZM7.75 1V0H7.13197L6.85557 0.552786L7.75 1ZM6.75 6H5.75V7H6.75V6ZM9.75 6V7H10.75V6H9.75ZM9.75 3H10.75V2H9.75V3ZM7.75 3L6.85557 2.55279L6.13197 4H7.75V3ZM8.75 1L9.64443 1.44721L10.368 0H8.75V1ZM4.75 3H5.75V2H4.75V3ZM4.75 6V7H5.75V6H4.75ZM2.75 3L1.85557 2.55279L1.13197 4H2.75V3ZM3.75 1L4.64443 1.44721L5.36803 0H3.75V1ZM2.75 1V0H2.13197L1.85557 0.552786L2.75 1ZM1.75 3L0.855573 2.55279L0.75 2.76393V3H1.75ZM1.75 6H0.75V7H1.75V6ZM7.64443 3.44721L8.64443 1.44721L6.85557 0.552786L5.85557 2.55279L7.64443 3.44721ZM7.75 6V3H5.75V6H7.75ZM9.75 5H6.75V7H9.75V5ZM8.75 3V6H10.75V3H8.75ZM7.75 4H9.75V2H7.75V4ZM7.85557 0.552786L6.85557 2.55279L8.64443 3.44721L9.64443 1.44721L7.85557 0.552786ZM7.75 2H8.75V0H7.75V2ZM3.75 3V6H5.75V3H3.75ZM2.75 4H4.75V2H2.75V4ZM3.64443 3.44721L4.64443 1.44721L2.85557 0.552786L1.85557 2.55279L3.64443 3.44721ZM3.75 0H2.75V2H3.75V0ZM1.85557 0.552786L0.855573 2.55279L2.64443 3.44721L3.64443 1.44721L1.85557 0.552786ZM2.75 6V3H0.75V6H2.75ZM4.75 5H1.75V7H4.75V5Z",
    fill: "white",
    mask: "url(#path-2-outside-1_28_1990)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYinyonglouceng);
export default __webpack_public_path__ + "static/media/yinyonglouceng.eb6112d7e9d2470b046f56c67991d790.svg";
export { ForwardRef as ReactComponent };